import { Component, OnInit,Inject, ViewEncapsulation, ViewChild,AfterViewInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/api.service';
import { CreateBmDialogComponent } from '../create-bm-dialog/create-bm-dialog.component';
import { EditBmComponent } from '../edit-bm/edit-bm.component';

@Component({
  selector: 'app-bord-members',
  templateUrl: './bord-members.component.html',
  styleUrls: ['./bord-members.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BordMembersComponent implements OnInit{
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] ;
  dataSource :any;
  showSpinner = false;
  screenwidth =null;
  dialogwidth = null;
  boardMemberList = [];
  filteredBMList = [];
  searchText;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  constructor(private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar) {
    
  }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }

    if(this.userRole =='admin'){
      this.displayedColumns = ['name','division', 'phone', 'id', 'created_at'];
    }else if(this.userRole =='manager'){
      this.displayedColumns = ['name','division', 'phone', 'id'];
    }
    this.refreshBMList();
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }

  refreshBMList(){
    this.showSpinner = true;
    this._apiService.getbmList().subscribe(res => {
      if (res) {
        this.boardMemberList = res;
        this.filteredBMList = res;
        this.dataSource = new MatTableDataSource<bmList>(res);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.showSpinner = false;
        console.log(this.boardMemberList);
      }
    },
    (error)=>{
      this.showSpinner = false;
       this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CreateBmDialogComponent, {
      width: this.dialogwidth,
      data: {boardMemberList: this.boardMemberList}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshBMList();
    });
  }

  // openEditBMDialog(bmdata): void{
  //   const dialogRef = this.dialog.open(EditBmComponent, {
  //     width: this.dialogwidth,
  //     data: {bmData: bmdata}
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.refreshBMList();
  //   });
  // }

  deleteBoardMember(data){
    this.showSpinner = true;
    this._apiService.deleteBM(data.id).subscribe(res => {
      if (res) {
        console.log(res);
        this.refreshBMList();
      }
    },
    (error)=>{
      this.showSpinner = false;
       this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  onSearch(e){
    if(e == null){
      this.filteredBMList = this.boardMemberList;
      this.dataSource = new MatTableDataSource<bmList>(this.boardMemberList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.filteredBMList = this.boardMemberList.filter(ele => ele.name.toLowerCase().includes(e.toLowerCase()));
    this.dataSource = new MatTableDataSource<bmList>(this.filteredBMList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

}


export interface bmList {
  id: number;
  name: string;
  phone: string;
  company_id: number;
  group_id: [];
  user_id: number;
  created_at:string;
  updated_at:string;
  division: string;
};



